var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-tabs',{staticClass:"mb-0",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#apps"}},[_vm._v("Apps")]),_c('v-tab',{attrs:{"to":"/admin/applications/vendors"}},[_vm._v("Accounts")])],1),_c('TabApps')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }